export default "__VITE_ASSET__B88gXqG0__"